import { Llmtestinput } from 'data/firestore/agent/llmtestinput/types';
import { EntityGet } from 'data/firestore/types';
import Option from './option';

interface InputsListProps {
    data?: EntityGet<Llmtestinput>[]
    onInputClick?: (input: Llmtestinput) => void
    onRequestDelete?: (inputId: string) => void
}
const InputsList = ({
    data = [],
    onInputClick = () => {},
    onRequestDelete = () => {},
}: InputsListProps) => (
    <>
        {data.map((input) => (
            <Option
                key={input.id}
                input={input}
                onClick={onInputClick}
                onDelete={onRequestDelete}
            />
        ))}
    </>
);

export default InputsList;
